import React, { useState } from "react";
import { useEffect } from "react";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { compareIgnoreCase } from "../../../utils/helpers.utils";

export default function ListBox(props) {
  const { firstList, secondList, resetFilter, defaultList } = props;
  const [firstListValues, setFirstListValues] = useState(firstList);
  const [selectedValue,setSelectedValue] = useState("");
  const [position,setPosition]=useState(secondList);
  const [isSelected, setIsSelected]=useState("");
  const [clearFilter, setClearFilter]=useState(resetFilter)
  const MoveLeft = () => {    
      let filterArray = [];   
      if (position.findIndex(r => r.FilterName == selectedValue && r.FieldType == "default") > -1) {
          return;
      }
      setPosition(position.filter((x)=>x.FilterName!==selectedValue))
      filterArray=position.filter((x)=>x.FilterName===selectedValue)
      setFirstListValues([...firstListValues, ...filterArray]);

      props.handleSelectedData(position.filter((x) => x.FilterName !== selectedValue))
  };

  const MoveRight = () => {
    let filterArray=[];   
    if (position.findIndex(r => r.FilterName == selectedValue && r.FieldType == "default") > -1) {
        return;
    }   
    setFirstListValues(firstListValues.filter((x)=>x.FilterName!==selectedValue))
    filterArray=firstListValues.filter((x)=>x.FilterName===selectedValue)
    setPosition([...position, ...filterArray]);    
    props.handleSelectedData([...position, ...filterArray]);
  };

 

  //tochange
  const HandleMovableList = (e) => { 
    setSelectedValue(e.target.title)   
    setIsSelected(e.target.id)
  };

  const MoveRightItem = (result)=>{    
   
    let filterArray=[];
    if (!result.destination) return;       
    if (result.source.droppableId !== result.destination.droppableId) {
      if(result.destination.droppableId==="selected") {
        filterArray=firstListValues.filter((_,x)=>x === result.source.index)
        setFirstListValues(firstListValues.filter((_,x)=>x !== result.source.index))
        setPosition([...position, ...filterArray]);
        props.handleSelectedData([...position, ...filterArray])
        
      } else if (result.destination.droppableId === "available") {
          if (position.findIndex(r => r.FilterId == result.draggableId && r.FieldType == "default") > -1) {
              return;
          }
        filterArray=position.filter((_,x)=>x === result.source.index)
        setPosition(position.filter((_,x)=>x !== result.source.index))
        setFirstListValues([...firstListValues, ...filterArray]);

        props.handleSelectedData(position.filter((_,x)=>x !== result.source.index))
      }
    } else {
      if(result.source.droppableId!=="available")
      {
        const items= Array.from(position);
        const [reorderItem]=items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem)
        setPosition(items)

        props.handleSelectedData(items)
      } else {
        return;
      }
       
    }
   
  }
  
  useEffect(()=>{     
    if(resetFilter){
        var notDefaultList = secondList?.filter(r => r.FieldType != "default") ?? [];

        var availableList = [
            ...firstList,
            ...notDefaultList
        ].sort((a, b) => compareIgnoreCase(a.FilterName, b.FilterName));

        setFirstListValues(availableList);
        setPosition(defaultList);
        props.handleSelectedData(defaultList);
        props.resetClearData(false);     
    }
  })

  return (
    <div className="list-box-container">
      <div className="list-box-header-container">
        <div className="list-box-available-container">
          <h1>Available</h1>
        </div>
        <div className="list-box-selected-container">
          <h1>Selected</h1>
          <span>Drag and drop to reorder item list</span>
        </div>
      </div>
      <div className="list-box-data-container">  
     
        <DragDropContext onDragEnd={result => MoveRightItem(result)}>
       
          <Droppable droppableId="available">
            {(provided,snapshot) => (
              <div className="characters" {...provided.droppableProps} ref={provided.innerRef} >
                {firstListValues.map((item, index) => (
                   <Draggable key={item.FilterId ? item.FilterId.toString() : "0"} draggableId={item.FilterId.toString()} index={index} isDragging={snapshot.isDragging}>
                        {(provided, snapshot) => (
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} title={item.FilterName} id={item.FilterId} value={item.FilterName} label={item.FilterName} onClick={HandleMovableList}
                                className={[isSelected == item.FilterId ? "isSelected" : "", snapshot.isDragging ? "box-shadow-dragging" : "box-shadow-none", "user-select"].join(" ")}
                            >
                            {item.FilterName}
                        </div>
                      )}
                 </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          <div className="list-box-button-container">        
            <div>
              <button className="rdl-move-right" onClick={() => MoveRight()}><span></span></button>
            </div>

            <div>
              <button  className="rdl-move-left" onClick={() => MoveLeft()}><span></span></button>
            </div>
          </div>
         
          <Droppable droppableId="selected">
                {(provided,snapshot) => (
                  <div className="selected" {...provided.droppableProps} ref={provided.innerRef}  >
                    {
                       position.map((item, index) => (
                          <Draggable key={item.FilterId ? item.FilterId.toString() : "0"} draggableId={item.FilterId ? item.FilterId.toString() : "0"} index={index}>
                            {(provided) => (
                                   <div title={item.FilterName} value={item.FilterName} id={item.FilterId} label={item.FilterName} onClick={HandleMovableList} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                       className={["user-select", isSelected == item.FilterId ? "isSelected color-red" : "color-black"].join(" ")}
                                    >
                                  {item.FilterName}
                              </div>
                            )}
                        </Draggable>
                      ))
                    }
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>     
          
        </DragDropContext>           
               
      </div>
     
    </div>
  );
}
